import Link from "next/link";
import { FaInstagram, FaFacebook, FaTiktok, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import { Logo } from "./header";

const navLinks = [
	{ label: "Startsidan", href: "/" },
	{ label: "Fordon i lager", href: "/fordon" },
	{ label: "Anläggningar", href: "/anlaggningar" },
	{ label: "Sälj ditt fordon", href: "/salj-ditt-fordon" },
	{ label: "Om oss", href: "/om-oss" },
	{ label: "Kontakt", href: "/kontakt" },
	{ label: "Garanti & Service", href: "/garantier" },
];

const socialLinks = [
	{
		label: "Facebook",
		href: "https://facebook.com/vdmotor.se",
		icon: FaFacebook,
		hoverColor: "hover:text-[#1877F2] hover:shadow-[#1877F2]/30",
	},
	{
		label: "Instagram",
		href: "https://instagram.com/vdmotorab",
		icon: FaInstagram,
		hoverColor: "hover:text-[#E4405F] hover:shadow-[#E4405F]/30",
	},
	{
		label: "TikTok",
		href: "https://www.tiktok.com/@vdmotor",
		icon: FaTiktok,
		hoverColor: "hover:text-white hover:shadow-white/20",
	},
];

const Footer = () => {
	return (
		<footer className="bg-deep mt-8">
			{/* Top accent line */}
			<div className="h-px bg-linear-to-r from-transparent via-accent to-transparent" />

			<div className="content-container px-4 2xl:px-0 py-12 lg:py-16">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
					{/* Column 1: Logo + tagline */}
					<div className="space-y-4">
						<div className="w-[165px]">
							<Logo />
						</div>
						<p className="text-gray-400 text-sm leading-relaxed">
							Din valda destination för högkvalitativa begagnade bilar. Handplockade fordon med trygghet och service i
							fokus.
						</p>
					</div>

					{/* Column 2: Navigation */}
					<div>
						<h3 className="text-sm uppercase font-semibold tracking-wider text-gray-300 mb-4">Navigation</h3>
						<ul className="space-y-2">
							{navLinks.map((link) => (
								<li key={link.href}>
									<Link
										href={link.href}
										className="text-gray-400 hover:text-white hover:translate-x-1 inline-flex transition-all duration-300 text-sm"
									>
										{link.label}
									</Link>
								</li>
							))}
						</ul>
					</div>

					{/* Column 3: Contact info */}
					<div>
						<h3 className="text-sm uppercase font-semibold tracking-wider text-gray-300 mb-4">Kontakt</h3>
						<ul className="space-y-3">
							<li>
								<Link
									href="tel:+461160501"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-300 text-sm"
								>
									<FaPhone className="text-accent shrink-0" />
									011-60 501
								</Link>
							</li>
							<li>
								<p className="text-sm">Norrköping</p>
								<Link
									href="mailto:info@vdmotor.se"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-300 text-sm"
								>
									<FaEnvelope className="text-accent shrink-0" />
									info@vdmotor.se
								</Link>
							</li>
							<li>
								<p className="text-sm">Jönköping</p>
								<Link
									href="mailto:jonkoping@vdmotor.se"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-300 text-sm"
								>
									<FaEnvelope className="text-accent shrink-0" />
									jonkoping@vdmotor.se
								</Link>
							</li>
							<li className="flex items-start gap-3 text-gray-400 text-sm">
								<FaClock className="text-accent shrink-0 mt-0.5" />
								<div>
									<p>Mån–fre: 10–18</p>
									<p>Lör: 11–14</p>
									<p>Sön: Stängt</p>
								</div>
							</li>
						</ul>
					</div>

					{/* Column 4: Social */}
					<div>
						<h3 className="text-sm uppercase font-semibold tracking-wider text-gray-300 mb-4">Följ oss</h3>
						<div className="flex gap-3">
							{socialLinks.map((social) => (
								<Link
									key={social.label}
									aria-label={`Gå till ${social.label}`}
									href={social.href}
									target="_blank"
									className={`text-gray-400 ${social.hoverColor} hover:scale-110 hover:shadow-lg transition-all duration-300 p-2 rounded-lg`}
								>
									<social.icon size={22} />
								</Link>
							))}
						</div>
					</div>
				</div>

				{/* Bottom bar */}
				<div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-center md:justify-between items-center gap-4 text-center md:text-left">
					<p className="text-gray-500 text-sm">
						&copy; {new Date().getFullYear()} V&D Motor Sweden AB. Alla rättigheter förbehållna.
					</p>

					<div className="flex gap-4">
						{socialLinks.map((social) => (
							<Link
								key={social.label}
								aria-label={`Gå till ${social.label}`}
								href={social.href}
								target="_blank"
								className={`text-gray-500 ${social.hoverColor} hover:scale-110 transition-all duration-300`}
							>
								<social.icon size={18} />
							</Link>
						))}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
